import React from 'react';
import PropTypes from 'prop-types';

import Alert from '../../../../common/informative/Alert';
import Table from '../../../../common/Table';

import { DEFAULT_PAGE_SIZE } from '../../../../../config/constants';
import { PREVENTIVE_TASK_EXECUTION_RESOURCE_COLUMNS } from '../../../../../config/columns';
import { filterMethodCaseInsensitive } from '../../../../../utils/filter-methods';

const PreventiveTaskExecutionResourceResource = ({
  preventiveTaskExecutionResourceList,
}) => {
  if (
    !Array.isArray(preventiveTaskExecutionResourceList) ||
    !preventiveTaskExecutionResourceList.length
  ) {
    return (
      <Alert
        message="La ejecución preventiva no tiene recursos ejecutados."
        type="warning"
      />
    );
  }

  return (
    <Table
      columns={PREVENTIVE_TASK_EXECUTION_RESOURCE_COLUMNS}
      data={preventiveTaskExecutionResourceList}
      filterable
      defaultFilterMethod={filterMethodCaseInsensitive}
      defaultPageSize={
        preventiveTaskExecutionResourceList.length <= 10
          ? preventiveTaskExecutionResourceList.length
          : DEFAULT_PAGE_SIZE
      }
      showPagination={preventiveTaskExecutionResourceList.length > 10}
      manual={false}
    />
  );
};

PreventiveTaskExecutionResourceResource.propTypes = {
  preventiveTaskExecutionResourceList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      preventiveTaskExecutionId: PropTypes.number,
      resourceId: PropTypes.number,
      companyResource: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      }),
      startedDate: PropTypes.number,
      completedDate: PropTypes.number,
      status: PropTypes.string,
      comment: PropTypes.string,
      createDate: PropTypes.number,
      lastUpdate: PropTypes.number,
    }),
  ),
};

PreventiveTaskExecutionResourceResource.defaultProps = {
  preventiveTaskExecutionResourceList: [],
};

export default PreventiveTaskExecutionResourceResource;
